import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapToolsService} from '../../services/map-tools.service';
import {SpatialUtilService} from '../../services/spatial-util.service';

@Component({
    selector: 'nlr-scale-features',
    imports: [CommonModule],
    templateUrl: './scale-features.component.html',
    styleUrl: './scale-features.component.scss'
})
export class ScaleFeaturesComponent implements OnInit {
    @Input()
    active: boolean;

    @Input()
    disabled: boolean;

    title: string = 'ScaleFeaturesComponent';

    constructor(
        private mapToolsService: MapToolsService,
        private spatialUtilService: SpatialUtilService
    ) {}

    ngOnInit() {
        this.mapToolsService
            .activate(
                'SCALE',
                () => this.spatialUtilService.refreshFeatureLayers(),
                () => this.spatialUtilService.refreshFeatureLayers(),
                () => this.disabled
            )
            .subscribe();
    }

    getTooltip() {
        return this.mapToolsService.getTooltipWithShortcut('SCALE', 'Toggle between the scaled & unscaled views');
    }

    isActive() {
        return this.mapToolsService.isScaleActive();
    }

    onClick() {
        this.mapToolsService.toggle('SCALE');
    }
}
